// extracted by mini-css-extract-plugin
export default {"contentBox":"ProfBackground_contentBox__GFbTj","emptyText":"ProfBackground_emptyText__s2Rx-"};